import {Navigate, Outlet} from 'react-router-dom';
import {useAuth} from '../../utils/auth.context';

export const ProtectedRoute = () => {
    const {isAuthenticated, user} = useAuth();

    if (user?.isRequest) {
        return <div></div> // loading
    }
    return isAuthenticated ? <Outlet/> : <Navigate to="/login"/>;
};

export const PublicRoute = () => {
    const {isAuthenticated, user} = useAuth();

    if (user?.isRequest) {
        return <div></div> // loading
    }
    return !isAuthenticated ? <Outlet/> : <Navigate to="/profile"/>;
};
